import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Navigate } from "react-router";
import { useCoreDoc } from "./useCoreDoc";
import { useDocSelector, useDocState } from "../core/useDocSelector";
import { useReadOnly } from "./useReadOnly";
import { ALL_SLUG, ensureAllDashboard } from "../dashboards/starter";
import { listDashboards } from "../dashboards/model";

/**
 * `/all` (the top bar's *All workspaces*, ADR 0024): opens the *All workspaces* dashboard, made from its preset the
 * first time (UI cleanup U2: it was a page of its own with the same three widgets).
 */
export function AllPage() {
  const { t } = useTranslation();
  const { handle, workspaceId } = useCoreDoc();
  const { settled } = useDocState(handle);
  const ro = useReadOnly(handle, workspaceId);
  const has = useDocSelector(handle, (doc) => listDashboards(doc).some((d) => d.slug === ALL_SLUG)) ?? false;
  useEffect(() => {
    if (handle && settled && !ro && !has) ensureAllDashboard(handle.doc);
  }, [handle, settled, ro, has]);
  if (has || (settled && ro)) return <Navigate to={`/d/${ALL_SLUG}`} replace />;
  return (
    <p className="p-8 text-neutral-500" role="status">
      {t("session.loading")}
    </p>
  );
}
